import { USER_ROLES } from '../ac/constants'
import StoreDeviceType from '../../redux/models/DeviceType'

/** Socket + DB use type id 3 for GPS trackers (see socket-service DEVICE_TYPE.GPS_TRACKER). */
export const GPS_TRACKER_TYPE_ID = 3

function normalizedRoleKey (value) {
  if (value == null || value === '') return ''
  return String(value).toLowerCase()
}

/** Chat group user members: agent, operator, or client (active / non-deleted). */
export function isChatGroupMemberRoleUser (user) {
  if (!user) return false
  const roleKey = normalizedRoleKey(user.roleId) ||
    normalizedRoleKey(user.role?.id) ||
    normalizedRoleKey(user.role?.name)
  return roleKey === USER_ROLES.AGENT ||
    roleKey === USER_ROLES.OPERATOR ||
    roleKey === USER_ROLES.CLIENT
}

/** @deprecated Prefer {@link isChatGroupMemberRoleUser}. Kept for callers that need agent-only. */
export function isAgentRoleUser (user) {
  if (!user) return false
  if (normalizedRoleKey(user.roleId) === USER_ROLES.AGENT) return true
  const nestedRole = user.role?.id ?? user.role?.name
  return normalizedRoleKey(nestedRole) === USER_ROLES.AGENT
}

export function isChatGroupTrackerDevice (device) {
  if (!device) return false
  const typeName = device.type?.name
  if (typeName === StoreDeviceType.DEVICE_TYPE_NAMES.TRACKER) return true
  const typeId = Number(device.typeId)
  if (typeId === GPS_TRACKER_TYPE_ID) return true
  // Trackers from /tracker API are stored as devices with uuid + no phone app fields
  if ((device.uuidDevice || device.uuid) && (device.licensePlate != null || device.password != null)) {
    return true
  }
  return false
}

export function isActiveChatGroupTrackerDevice (device) {
  if (!isChatGroupTrackerDevice(device)) return false
  if (device.isActive === false || device.enabled === false) return false
  if (device.isDeleted === true) return false
  return true
}

export function isActiveChatGroupUser (user) {
  if (!user) return false
  if (user.isActive === false) return false
  if (user.isDeleted === true) return false
  return isChatGroupMemberRoleUser(user)
}

/** Member user ids from a chat group record (socket list row, REST DTO, or store JSON). */
export function resolveChatGroupMemberUserIds (chatGroup) {
  if (!chatGroup) return []
  const fromIds = chatGroup.userIds ?? chatGroup.user_ids
  if (Array.isArray(fromIds)) {
    return [...new Set(fromIds.map(id => String(id)).filter(Boolean))]
  }
  const fromUsers = chatGroup.users?.map(u => u?.id).filter(Boolean) ?? []
  if (fromUsers.length > 0) {
    return [...new Set(fromUsers.map(id => String(id)))]
  }
  return []
}

export function resolveChatGroupMemberDeviceIds (chatGroup) {
  if (!chatGroup) return []
  const fromIds = chatGroup.deviceIds ?? chatGroup.device_ids
  if (Array.isArray(fromIds)) {
    return [...new Set(fromIds.map(id => String(id)).filter(Boolean))]
  }
  const fromDevices = chatGroup.devices?.map(d => d?.id || d?.uuid_device || d?.uuid).filter(Boolean) ?? []
  if (fromDevices.length > 0) {
    return [...new Set(fromDevices.map(id => String(id)))]
  }
  return []
}

/** Value stored in chat group deviceIds / sent to socket (tracker uuid). */
export function getChatGroupTrackerOptionId (device) {
  return device.uuidDevice || device.uuid || device.id
}
